const translationsFR = {
  adsTitle: 'Publicité',
  and: 'et',
  'author.by': 'par',
  back: 'Retour',
  'blickTVStory.chapterTitle': 'Toutes les séquences du live',
  'blickTVStory.goToLive': 'Revenir au live',
  'blickTVStory.live': 'LIVE',
  'blickTVStory.restartCurrentChapter': 'Revenir au début de la séquence',
  close: 'Fermer',
  'commenting.answer': 'Répondre',
  'commenting.answerPlaceholder': 'Ecrivez une réponse...',
  'commenting.answerPlaceholderEmailOnly':
    'Complétez votre profil ici pour répondre...',
  'commenting.answerPlaceholderNotLoggedIn':
    'Connectez-vous et écrivez une réponse...',
  'commenting.authorType.admin': 'Administrateur',
  'commenting.authorType.admin.female': 'Administratrice',
  'commenting.authorType.journalist': 'Journaliste',
  'commenting.authorType.journalist.female': 'Journaliste',
  'commenting.authorType.moderator': 'Modérateur',
  'commenting.authorType.moderator.female': 'Modératrice',
  'commenting.authorType.user': 'Utilisateur',
  'commenting.cancel': 'Annuler',
  'commenting.commentingRulesText': 'La charte des ',
  'commenting.commentingRulesLinkText': 'Сommentaires.',
  'commenting.commentPlaceholder': 'Ecrivez un commentaire...',
  'commenting.commentPlaceholderEmailOnly':
    'Complétez votre profil ici pour commenter...',
  'commenting.commentPlaceholderNotLoggedIn':
    'Connectez-vous et écrivez un commentaire...',
  'commenting.delete': 'Supprimer',
  'commenting.deleteConfirmation':
    'Voulez-vous vraiment supprimer ce commentaire?',
  'commenting.deletedUserName': 'Cet utilisateur a supprimé le compte',
  'commenting.loadMoreAnswers': 'Montrer plus de réponses',
  'commenting.loadMoreComments': 'Afficher plus de commentaires',
  'commenting.noAvailableComments':
    'Aucun commentaire disponible pour le moment.',
  'commenting.numberOfCharactersLeft':
    'Encore {{numberOfCharacters}} caractères restants',
  'commenting.numberOfCharactersOverflow':
    '{{numberOfCharacters}} trop de caractères',
  'commenting.oneCharacterLeft': '1 caractère restant',
  'commenting.oneCharacterOverflow': '1 caractère en trop',
  'commenting.postCommentSentMessage':
    'Merci beaucoup, votre commentaire va être examiné.',
  'commenting.postSubmit': 'Commenter',
  'commenting.report': 'Signaler',
  'commenting.reportTitle': 'Motif du signalement',
  'commenting.reportedMessage': 'Merci pour votre message.',
  'commenting.title.all': 'Tous les commentaires',
  'commenting.title.top': 'Voix sélectionnées',
  'commenting.to': 'à',
  'config.gdprTitle': 'Protection des données',
  dossier: 'Dossier',
  'errorPage.errorStatus': 'Erreur {{errorStatus}}',
  'errorPage.helpMessage':
    'Utilisez la navigation ci-dessus pour trouver cet article ou un autre.',
  'errorPage.pageNotFound': 'Malheureusement, cette page n’existe pas',
  'errorPage.unknownErrorMessage': 'Une erreur s’est produite',
  'footer.ringierFooterTitle': 'Plus de Ringier',
  'formIO.loginRequiredButtonText': 'Se connecter',
  'formIO.loginRequiredText': 'Veuillez vous inscrire pour participer!',
  'formIO.noEmailOnlyRequiredButtonText': 'Vers le profil',
  'formIO.noEmailOnlyRequiredText': 'Complétez votre profil pour participer',
  'formIO.submissionMessage': 'Nous vous remercions de votre participation!',
  'gallery.closeFullscreen': 'Fermer en plein écran',
  'immo.title': 'Trouvez la propriété de vos rêves',
  lastUpdated: 'Dernière mise à jour',
  less: 'Moins',
  lessThanMinute: 'il y a 1 minute',
  lessThanNMinutes: 'il y a {{diffMinutes}} minutes',
  'liveEvent.cancelled': 'Supprimé',
  'liveEvent.finished': 'Terminé',
  'liveEvent.lap': 'Tour',
  'liveEvent.live': 'EN DIRECT',
  'liveEvent.skiFirstRun': '1er Exécuter',
  'liveEvent.skiSecondRun': '2e Exécuter',
  'livecenter.live': 'En direct',
  'livecenter.sporttip': 'Sporttip',
  'livecenter.title': 'Live Center',
  'login.logout': 'Déconnexion',
  'login.myAccount': 'Mon compte',
  'lotto.chf': 'CHF',
  'lotto.drawingFrom': 'En s’inspirant de {{drawDate}}',
  'lotto.luckyNumber': '+ numéro chanceux',
  'lotto.nextDraw': 'Prochain tirage: {{nextDate}}',
  'lotto.nextJackpot': 'Prochain jackpot',
  'lotto.nowPlaying': 'Jouer maintenant',
  'lotto.numberOfWinners': 'Nombre de gagnants',
  'lotto.prizeCategories': 'Rangs gagnants',
  'lotto.profit': 'Gain',
  'matchStatus.afterExtraTime': 'Après prolongation',
  'matchStatus.afterPenalty': 'Après la séance de tirs au but',
  'matchStatus.calledOff': 'Annulé',
  'matchStatus.cancelled': 'Interrompu',
  'matchStatus.ended': 'Terminé',
  'matchStatus.interrupted': 'Interruption',
  'matchStatus.overtime': 'Prolongation',
  'matchStatus.penaltiesRunning': 'Tirs au but',
  more: 'plus',
  next: 'Suite',
  'optOut.catchword': 'Protection des données',
  'optOut.checkbox.in':
    'L’outil de suivi Ringier est actuellement désactivé. Cliquez ici pour l’activer',
  'optOut.checkbox.out':
    'L’outil de suivi Ringier est actuellement activé. Cliquez ici pour le désactiver',
  'optOut.cmpOverlayHint':
    'Pour modifier les paramètres de traitement de vos données, ',
  'optOut.cmpOverlayLink': 'cliquez ici.',
  'optOut.hint':
    'Vous pouvez déterminer ici si vous souhaitez désactiver certaines technologies telles que l’outil de suivi Ringier.',
  'optOut.title': 'Vos paramètres',
  published: 'Publié',
  'published.at': 'à',
  'recipe.ingredients': 'Ingrédients',
  'recipe.portions': 'Portions',
  'recipe.nutrition': 'Calories par portion',
  'recipe.prepTime': 'Temps de préparation',
  'recipe.cookTime': 'Temps de cuisson',
  'recipe.instructions': 'Instructions',
  'recipe.step': 'Étape',
  'recommendation.title': 'Ceci pourrait aussi vous intéresser',
  'scribble.failed':
    'Le téléscripteur de nouvelles n’a pas pu être chargé. Rechargez l’article pour réessayer.',
  'scribble.failedBolded': 'Et hop! ',
  'scribble.loadMore': '{{numberOfItems}} autres entrées',
  'scribble.loadOneMore': 'Une autre entrée',
  'scribble.loading': 'Newsticker invite...',
  'scribble.loadingEntry': 'Chargement de l’entrée Liveticker',
  'scribble.topPost': 'Article top',
  'search.defaultButtonTitle': 'Rechercher',
  'search.description':
    'Enregistrez-vous gratuitement et bénéficiez d’un accès illimité à tous les contenus de Blick.ch.',
  'search.errorMessage':
    'La recherche n’est actuellement pas disponible. Veuillez réessayer dans quelques instants.',
  'search.input': 'Recherche...',
  'search.loading': 'Recherche en cours...',
  'search.moreInfoLabel': 'En savoir plus',
  'search.noResultsExplanation': 'Aucun résultat de recherche trouvé',
  'search.of': 'de',
  'search.onlyOneSearchResult': 'Résultat de la recherche',
  'search.page': 'Page',
  'search.searchResults': 'Résultats de la recherche',
  'search.title': 'Vous voulez en voir plus?',
  'search.toLoginLabel': 'S’inscrire',
  shareMessage: 'Partagé via Blick',
  'social.copyToast': 'Link copié',
  'sportTable.goalDiffTotal': 'DB.',
  'sportTable.matchesTotal': 'J.',
  'sportTable.name': 'Equipe',
  'sportTable.pointsTotal': 'PT.',
  submit: 'Envoyer',
  'topList.title': 'Les plus visionnées',
  'topStories.defaultTitle': 'Top Topics',
} as const

export type TranslationsFR = typeof translationsFR

export default translationsFR
